import { Form, Input, Modal, Image } from "antd";
import { NumericInput } from "components/NumericInputField";
import { TextButton } from "components/TextButton";
import styled from "styled-components";

export const CreateOrderModalWrapper = styled(Modal)`
  top: calc(calc(100% - 400px) / 2);
  @media(min-width: 1600px){
    min-width: 700px;
  }
  .ant-modal-content {
    background: #000;
    border-radius: 10px;
    border: #cff54d 1px solid;
  }
  .ant-modal-body {
    background: #000;
    border-radius: 10px;
    padding: 18px 44px;
    padding-bottom: 25px;
  }
  .ant-form-item-label {
    font-size: 10px;
    font-weight: 400;
    color: white;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 56px;
`;

export const WrapperContent = styled.div``;

export const TitleStyled = styled.p`
  font-size: 20px;
  color: #ffffff;
  font-weight: 700;
  @media(min-width: 1400px){
    font-size: 22px;
  }
  @media(min-width: 1600px){
    font-size: 26px;
  }
`;

export const BottomButton = styled(TextButton)`
  border-radius: 10px;
  width: fix-content;
  height: 40px;
  display: flex;
  margin-top: -24px;
  background: transparent !important;
  color: #cff54d !important;
  justify-content: center;
  align-items: center;
  :disabled,
  :disabled:hover {
    background-color: transparent;
    opacity: 0.6;
    background-image: none !important;
  }
  :hover, :focus {
    background: transparent;
    color: #cff54d;
  }
  @media(min-width: 1400px){
    font-size: 17px;
  }
  @media(min-width: 1600px){
    font-size: 20px;
  }
`;

export const FormItemInput = styled(Form.Item)`
  padding: 0px;
`;

export const FormItemSelect = styled(Form.Item)`
  padding: 0px;
  color: #fff;
  margin: 0;
  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector{
    color: #ccc;
  }
`;

export const FormItemButton = styled(Form.Item)`
  margin: 0;
  text-align: center;
  .ant-image{
    height: 0;
  }
  .ant-btn:before{
    background-color: transparent;
  }
`;

export const NumericInputWrapper = styled(NumericInput)`
  border: 1px solid #d9d9d9;
  color: #fff;
`;

export const InputWrapper = styled.div`
  width: 100%;
  border-radius: 24px;
  border: 1px solid #cff54d;
  background-color: transparent;
  line-height: 18px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1px 8px 1px 0px;
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }
`;
export const InputField = styled(Input)`
  width: 70%;
  background: transparent;
  border: none;
  color: #fff;
  font-weight: 600;
  font-size: 14px;
  :disabled,
  :disabled:hover {
    background-color: transparent !important;
    color: #fff !important;
  }
  @media(min-width: 1400px){
    font-size: 18px;
  }
  @media(min-width: 1600px){
    font-size: 20px;
  }
`;
export const LabelWrapper = styled.label`
  font-size: 12px;
  color: #fff;
  font-weight: 400;
  @media(min-width: 1400px){
    font-size: 14px !important;
  }
  @media(min-width: 1600px){
    font-size: 18px !important;
  }
`;

export const TextWrapper = styled.div`
  font-size: 15px;
  color: #fff;
  font-weight: 400;
  text-align: center;
  @media(min-width: 1600px){
    font-size: 18px;
  }
`;

export const SelectIcon = styled(Image)`
  width: 20px;
`;

export const ButtonBackground = styled(Image)`
  position: relative;
  top: 6px;
  @media(min-width: 1300px){
    width: 158px;
  }
`;
